// extracted by mini-css-extract-plugin
export var arrow = "_2a-6";
export var changeItem = "_2a-3";
export var changesHeader = "_2a-1";
export var changesList = "_2a-2";
export var container = "_2a-0";
export var pathLabel = "_2a-4";
export var value = "_2a-7";
export var valuesContainer = "_2a-5";